import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";

import { ApiService } from "@bitwarden/common/abstractions/api.service";
import { UpdateProfileRequest } from "@bitwarden/common/auth/models/request/update-profile.request";
import { I18nService } from "@bitwarden/common/platform/abstractions/i18n.service";
import { DIALOG_DATA, DialogRef, DialogService, ToastService } from "@bitwarden/components";

import { SharedModule } from "../../../shared";

export type EditNameDialogData = {
  name: string;
};

@Component({
  templateUrl: "edit-name-dialog.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedModule],
})
export class EditNameDialogComponent {
  readonly formGroup = new FormGroup({
    name: new FormControl("", { nonNullable: true }),
  });

  constructor(
    @Inject(DIALOG_DATA) data: EditNameDialogData,
    private readonly dialogRef: DialogRef,
    private readonly apiService: ApiService,
    private readonly i18nService: I18nService,
    private readonly toastService: ToastService,
  ) {
    this.formGroup.controls.name.setValue(data.name);
  }

  clearName(): void {
    this.formGroup.controls.name.setValue("");
  }

  readonly submit = async () => {
    const request = new UpdateProfileRequest(this.formGroup.controls.name.value);
    await this.apiService.putProfile(request);
    this.toastService.showToast({
      variant: "success",
      message: this.i18nService.t("accountUpdated"),
    });
    void this.dialogRef.close(this.formGroup.controls.name.value);
  };

  static open(dialogService: DialogService, data: EditNameDialogData) {
    return dialogService.open(EditNameDialogComponent, { data });
  }
}
